module.exports = __webpack_public_path__ + "static/media/dog-barking.0db6a94e.gif";